import React from 'react';
import PropTypes from 'prop-types';

import TextFieldStyled from './Select.styled';

const SelectField = ({
  field: { name, value, onChange, onBlur },
  form: { errors, touched },
  label,
  required,
  variant,
  fullWidth,
  disabled,
  selectProps,
  options,
  placeholder,
  asyncErrors,
  ...props
}) => {
  const handleShowError = () => {
    if (asyncErrors) {
      return asyncErrors;
    } else if (errors[name] && touched[name] && errors[name]) {
      return errors[name];
    }
  };

  const handleError = () => {
    if (asyncErrors) {
      return true;
    } else if (errors && errors[name] && touched && touched[name]) {
      return true;
    }
  };

  return (
    <TextFieldStyled
      select
      name={name}
      label={label}
      value={value}
      margin="normal"
      onBlur={onBlur}
      variant={variant}
      onChange={onChange}
      required={required}
      disabled={disabled}
      fullWidth={fullWidth}
      selectprops={{
        native: true,
        ...selectProps,
      }}
      error={handleError()}
      helperText={handleShowError()}
      {...props}
    >
      <option hidden>{placeholder}</option>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </TextFieldStyled>
  );
};

SelectField.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
  }),
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
  }),
  selectProps: PropTypes.object,
  options: PropTypes.array.isRequired,
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled']),
};

SelectField.defaultProps = {
  required: true,
  selectProps: {},
  fullWidth: true,
  disabled: false,
  form: {
    errors: {},
    touched: {},
  },
  variant: 'standard',
  placeholder: 'Select...',
};

export default SelectField;
